<template>
  <div v-pin="{padding: {top: 136}}" class="c-operation">
    <v-layout class="card app-bg" column justify-center align-center>
      <template v-if="isLogin && iscode">
        <v-flex v-if="this.code === '1001'">
          <v-btn class="card-btn" color="primary" outline large @click="check(1)">保费试算</v-btn>
        </v-flex>
        <v-flex class="mt-2">
          <v-btn class="card-btn" color="primary" large @click="check(2)">投保</v-btn>
        </v-flex>
      </template>
      <template  v-else-if="this.code === '1074' && !isLogin">
        <v-flex class="mt-2">
          <v-btn class="card-btn" color="primary" large @click="check(3)">投保</v-btn>
        </v-flex>
      </template>
      <template v-else>
        <v-flex class="text">如需详细报价请咨询客服</v-flex>
        <v-flex class="mt-3">
          <table class="text2">
            <tr>
              <td>补充医疗客服：</td>
              <td>4006-234-345</td>
            </tr>
            <tr>
              <td>天津总部电话：</td>
              <td>4006-234-345</td>
            </tr>
            <tr>
              <td>北京分公司电话：</td>
              <td>4006-234-345</td>
            </tr>
            <tr>
              <td>陕西分公司电话：</td>
              <td>4006-234-345</td>
            </tr>
          </table>
        </v-flex>
        <v-flex class="mt-4">——————— 或 ———————</v-flex>
        <v-flex class="text2 mt-3">当地的易才分支机构</v-flex>
      </template>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    code: String
  },
  methods: {
    check(type) {
      if (type === 1) {
        this.$router.push(`/plan/${this.code}`);
      } else if (type === 3) {
        this.$messageBox.alert("产品报备中");
      }else {
        this.insure();
      }
    },
    insure() {
      if (!this.isLogin) {
        this.$store.dispatch("callLogin");
        return false;
      }
      this.$router.push(`/insure/${this.code}`);
    }
  },
  computed:{
    iscode(){
      return ['1001','1074','1075'].includes(this.code);
    }
  }
};
</script>

<style lang="scss" scoped>
.c-operation {
  .card {
    padding: 30px 25px;
    margin-bottom: 20px;
    .card-btn {
      width: 280px;
    }
  }
}
</style>

